import { useBreakpointV2 } from "@tm/ui-widgets";
//import { Header as MMTHeader } from 'pwa-mmt-ui-header/ssr/header';
import { getCookieByName } from "@tm/insurance/utils";
import { PARTNER } from "@tm/isomorphic-utils";
import dynamic from "next/dynamic";
import Router from "next/router";

const DynamicMMTHeader = dynamic<any>(
  () => import("pwa-mmt-ui-header/ssr/header").then((module) => module.Header),
  { ssr: true }
);

const DynamicLandingHeaderMobile = dynamic<any>(
  () => import("..").then((module) => module.LandingHeaderMobile),
  { ssr: true }
);
export interface MMTHeaderProps {
  type?: "singleHeader" | "dualHeader";
  forceLogin?: boolean;
  activeModal?: string;
  showMyBizFormSwitcher?: boolean;
  profile?: "PERSONAL" | "BUSINESS";
  displayLanguageDropdown?: boolean;
  selectedTabName?:
    | "Flights"
    | "Hotels"
    | "Holidays"
    | "Buses"
    | "Cabs"
    | "Trains"
    | "Giftcards"
    | "Travel Insurance";
  displayCurrencyDropdown?: boolean;
  showMoreButton?: boolean;
  showLoginPersuasionSlider?: boolean;
  multiLingualData?: {
    "header.login.signup.for.best.prices"?: string;
  };
  onLogin?: () => void;
  onLoginFlowComplete?: () => void;
  onModalChange?: (modal: "LOGIN" | undefined) => void;
  pokusExperiments?: {
    insuranceNewFunnel?: boolean;
  };
  globalConfig?: any;
  headerCommonData?: {
    loyaltyHeaderData?: any;
    walletHeaderData?: any;
    mobileCore?: any;
    userInfoData?: any;
  };
}

interface MMTAuthProps {
  forceLogin?: boolean;
  headerProps?: MMTHeaderProps;
  mobileTitle?: string;
  myOrders?: boolean;
  goToMyOrders?: () => void;
  displayWhiteHeader?: boolean;
  isMyBiz?: boolean;
  exitWebViewOnBack?: boolean;
  showPwaHeaderBackButton?: boolean;
  showPwaHeader?: boolean;
}

export function MMTInsuranceHeader({
  headerProps = {},
  mobileTitle = "",
  myOrders,
  goToMyOrders,
  displayWhiteHeader,
  isMyBiz,
  exitWebViewOnBack = false,
  showPwaHeaderBackButton = true,
  showPwaHeader = true,
}: MMTAuthProps) {
  const device = useBreakpointV2();

  let headerPropsWithDefaults: MMTHeaderProps = {
    type: "singleHeader",
    forceLogin: false,
    activeModal: undefined,
    showMyBizFormSwitcher: true,
    profile: "PERSONAL",
    displayLanguageDropdown: false,
    selectedTabName: "Travel Insurance",
    displayCurrencyDropdown: false,
    pokusExperiments: {
      insuranceNewFunnel: getCookieByName("isCommonLanding") === "true",
    },
    onLogin: () => {
      if (getCookieByName("next_page_req")) {
        window.location.href = `https://insurance.makemytrip.com/insurance/next-page`;
      } else Router.reload();
    },
    onLoginFlowComplete: () => void 0,
    onModalChange: () => void 0,
    showMoreButton: true,
    showLoginPersuasionSlider: false,
    multiLingualData: {
      "header.login.signup.for.best.prices":
        "Please login to purchase your travel insurance",
    },
    globalConfig: null,
    headerCommonData: {
      loyaltyHeaderData: null,
      walletHeaderData: null,
      mobileCore: null,
      userInfoData: null,
    },
    ...headerProps,
  };
  if (headerPropsWithDefaults.type === "dualHeader") {
    headerPropsWithDefaults.showMoreButton = false;
  }
  if (headerPropsWithDefaults?.forceLogin) {
    headerPropsWithDefaults = {
      ...headerPropsWithDefaults,
      activeModal: "LOGIN",
    };
    return <DynamicMMTHeader {...headerPropsWithDefaults} />;
  }
  return isMyBiz && device === "lg" ? null : device === "lg" ? (
    <DynamicMMTHeader {...headerPropsWithDefaults} />
  ) : showPwaHeader ? (
    <DynamicLandingHeaderMobile
      headerTitle={mobileTitle}
      myOrders={myOrders}
      goToMyOrders={goToMyOrders}
      displayWhiteHeader={displayWhiteHeader}
      partnerType={PARTNER.MMT}
      insuranceHeader
      exitWebViewOnBack={exitWebViewOnBack}
      showPwaHeaderBackButton={showPwaHeaderBackButton}
    />
  ) : null;
}
